import { deletePaymentMethod, } from '../types'
import HttpService from '../../services/HttpService'

export const deletePaymentMethodAction = paymentMethodID => {
  return async dispatch => {
    
    dispatch({ type: deletePaymentMethod.DELETE_PAYMENT_METHOD_ERROR, })

    let storage
    try {
      storage = JSON.parse(localStorage.getItem("user-token"))
    } catch (err) {
      return dispatch({ 
        type: deletePaymentMethod.DELETE_PAYMENT_METHOD_ERROR, 
        payload: message,
      })
    }
    const http = new HttpService()
    await http.deleteData(
      '/users/'+storage.data.user.id+'/payment-methods/'+paymentMethodID,
      "user-token",
    )
      .then(res => {
        dispatch({
          type: deletePaymentMethod.DELETE_PAYMENT_METHOD_SUCCESS,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: deletePaymentMethod.DELETE_PAYMENT_METHOD_ERROR, 
          payload: message,
        })
      })
  }
}